import type { PlotjackStorageAdapter } from '@plotjack/core';

export const webStorageAdapter: PlotjackStorageAdapter = {
  async getItem(key: string) {
    return localStorage.getItem(key);
  },
  async setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  },
  async removeItem(key: string) {
    localStorage.removeItem(key);
  },
};
